(function () {
  var REDIRECT_GUARD_KEY = "dreambaby-locale-redirect-done";

  try {
    if (window.sessionStorage.getItem(REDIRECT_GUARD_KEY) === "1") return;
  } catch (error) {
    // Ignore storage errors and continue without the guard.
  }

  var localization = window.dreambabyLocalization || {};
  var currentLanguageIsoCode = (
    localization.currentLanguageIsoCode || ""
  ).toLowerCase();
  var availableLanguages = Array.isArray(localization.availableLanguages)
    ? localization.availableLanguages
    : [];

  if (currentLanguageIsoCode.indexOf("fr") === 0) {
    try {
      window.sessionStorage.setItem(REDIRECT_GUARD_KEY, "1");
    } catch (error) {
      // Ignore storage errors.
    }
    return;
  }

  var browserLanguage = (navigator.language || "").toLowerCase();
  if (browserLanguage.indexOf("fr") !== 0) return;

  var frenchLocale = availableLanguages.find(function (locale) {
    return (
      (locale && locale.isoCode ? locale.isoCode.toLowerCase() : "").indexOf(
        "fr",
      ) === 0
    );
  });

  if (!frenchLocale || !frenchLocale.rootUrl) return;

  var currentPath = window.location.pathname || "/";
  var targetRoot = frenchLocale.rootUrl;
  var isAlreadyOnTargetLocale =
    currentPath === targetRoot || currentPath.indexOf(targetRoot + "/") === 0;
  if (isAlreadyOnTargetLocale) {
    try {
      window.sessionStorage.setItem(REDIRECT_GUARD_KEY, "1");
    } catch (error) {
      // Ignore storage errors.
    }
    return;
  }

  var targetPath = targetRoot === "/" ? currentPath : targetRoot + currentPath;

  try {
    window.sessionStorage.setItem(REDIRECT_GUARD_KEY, "1");
  } catch (error) {
    // Ignore storage errors.
  }

  window.location.replace(
    targetPath + window.location.search + window.location.hash,
  );
})();